export default function TestimonialSection() {
  return (
    <section id="reviews" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[40%]">
            <div className="rounded-[32px] overflow-hidden aspect-[4/5] bg-accent-100 w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Smiling%20young%20professional%20woman%20working%20on%20laptop%20at%20bright%20modern%20home%20office%20desk%2C%20warm%20natural%20daylight%20streaming%20through%20large%20window%2C%20cream%20beige%20interior%20with%20plants%20and%20organized%20workspace%2C%20scandinavian%20minimal%20aesthetic%2C%20soft%20gentle%20shadows%2C%20calm%20focused%20productive%20atmosphere%2C%20authentic%20candid%20lifestyle%20photography&width=600&height=750&seq=testimonial-v2&orientation=portrait"
                alt="User working with ACBuySpreadsheet system"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%]">
            <span className="text-xs text-foreground-400 font-medium tracking-wide">
              (Verified User Feedback)
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
              Why Users Love
              <br />
              <span className="text-foreground-300">ACBuy Spreadsheet</span>
            </h2>

            <blockquote className="mt-8 md:mt-10 border-l-2 border-primary-300 pl-5 md:pl-6">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed italic">
                &ldquo;The ACBuySpreadsheet system has completely transformed how I manage my purchasing workflow. The spreadsheet-based tracking is intuitive, fast, and incredibly accurate. I can monitor orders in real-time and make data-driven decisions that have saved me hours every week. It is the most structured buying tool I have ever used.&rdquo;
              </p>
            </blockquote>

            <div className="mt-6 flex items-center gap-4">
              <div className="w-px h-8 bg-primary-300"></div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Sarah Mitchell</p>
                <p className="text-xs text-foreground-400">E-commerce Operations Manager</p>
              </div>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <button className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center cursor-pointer hover:border-foreground-400 transition-colors">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-line text-foreground-500"></i>
                </span>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-colors">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}